__turbopack_context__.v({
  "buttonContainer": "styles-module-scss-module__sJwMrW__buttonContainer",
  "categoryButton": "styles-module-scss-module__sJwMrW__categoryButton",
  "infoPrompt": "styles-module-scss-module__sJwMrW__infoPrompt",
  "promptLink": "styles-module-scss-module__sJwMrW__promptLink",
  "sizeTable": "styles-module-scss-module__sJwMrW__sizeTable",
  "sizeTableContainer": "styles-module-scss-module__sJwMrW__sizeTableContainer",
});
